"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-type-assertion/no-type-assertion */
const react_1 = require("react");
const Canvas = ({ width }) => {
    function isCanvas(obj) {
        return (obj === null || obj === void 0 ? void 0 : obj.tagName) === 'CANVAS';
    }
    (0, react_1.useEffect)(() => {
        const video = document.getElementById('livestream');
        const canvas = document.getElementById('canvas');
        if (isCanvas(canvas)) {
            canvas.width = video === null || video === void 0 ? void 0 : video.videoWidth;
            canvas.height = video === null || video === void 0 ? void 0 : video.videoHeight;
            const canvas2d = canvas.getContext('2d');
            canvas2d === null || canvas2d === void 0 ? void 0 : canvas2d.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)("canvas", { id: 'canvas', width: width, style: { width } }));
};
exports.default = Canvas;
